// extracted by mini-css-extract-plugin
export default {"container":"qDPjwPU5sZdiN7l7QnrM"};